import React from 'react';
import {
  Box, Typography,
} from 'vindi-ds-components';
import ListProducts from './list_products';
import PriceField from './price_field';

function PricePerUnit() {
  return (
    <Box marginBottom='2em'>
      <Box display='flex' flexDirection='flex-start' alignItems='center' css={{ gap: '0.5em' }}>
        <PriceField />
        <Box display='flex' alignItems='center'>
          <Typography variant='body2' style={{ padding: '1em' }}>por</Typography>
          <Box paddingBottom='5px' marginBottom='1.1em'>
            <ListProducts />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default PricePerUnit;
